module.exports = __webpack_public_path__ + "static/img/sand_11_max.43c399d0.png";